import type {
  MouseEvent as ReactMouseEvent,
  PointerEvent as ReactPointerEvent,
} from 'react';

const SHELL_FOCUS_BLOCK_SELECTOR =
  'button, a, input, textarea, select, [role="button"], [contenteditable="true"], [data-composer-no-shell-focus], [data-radix-popper-content-wrapper]';

/** Focus the prompt when the user clicks composer padding/border, not controls. */
export const shouldComposerShellFocus = (target: EventTarget | null): boolean => {
  if (!(target instanceof Element)) return false;
  return !target.closest(SHELL_FOCUS_BLOCK_SELECTOR);
};

/**
 * Bind to `onMouseDown`. Preventing a primary press keeps the prompt focused and
 * stops a double click from word-selecting text outside the card; acting on the
 * press rather than the click leaves a drag-select that ends over the padding
 * intact. Other buttons keep their native behaviour (context menu, autoscroll).
 */
export const handleComposerShellClick = (
  event: ReactMouseEvent<HTMLElement>,
  focus: () => void
): void => {
  if (event.button !== 0 || !shouldComposerShellFocus(event.target)) return;
  event.preventDefault();
  focus();
};

/** Marks transcript engagement so post-send refocus can be suppressed. */
export const handleTranscriptEngagement = (
  event: ReactPointerEvent<HTMLElement>,
  onEngage: () => void
): void => {
  if (!shouldComposerShellFocus(event.target)) return;
  onEngage();
};
